import { render, staticRenderFns } from "./SaleReturnList.vue?vue&type=template&id=6686b7a1"
import script from "./SaleReturnList.vue?vue&type=script&lang=js"
export * from "./SaleReturnList.vue?vue&type=script&lang=js"
import style0 from "./SaleReturnList.vue?vue&type=style&index=0&id=6686b7a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports